
    import * as React from 'react';

    const Expand20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" style={svgStyle}><path d="M10.5 2H9.5V9.5H2V10.5H9.5V18H10.5V10.5H18V9.5H10.5V2Z" /></svg>
        </div>
      );
    };

    Expand20.displayName = 'Expand20';

    export default Expand20;
  